import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-navy text-gray-300 pt-20 pb-10" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-37">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-38">
            <Link to="/" className="flex items-center text-3xl font-heading font-extrabold tracking-tight" data-id="element-39">
              <span className="text-white" data-id="element-40">RAPID</span>
              <span className="text-brand-amber ml-1" data-id="element-41">ENERGY</span>
            </Link>
            <p className="text-sm leading-relaxed text-gray-400" data-id="element-42">
              Trusted temporary HVAC solutions. We provide high-efficiency
              heating and cooling equipment for critical operations across the
              UK.
            </p>
            <div className="flex items-center space-x-4 pt-2" data-id="element-43">
              <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-amber transition-colors cursor-pointer" data-id="element-44">
                <span className="text-white font-bold" data-id="element-45">in</span>
              </div>
              <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-amber transition-colors cursor-pointer" data-id="element-46">
                <span className="text-white font-bold" data-id="element-47">X</span>
              </div>
            </div>
          </div>

          {/* Equipment Hire */}
          <div data-id="element-48">
            <h4 className="text-white font-heading font-bold text-lg mb-6" data-id="element-49">
              Equipment Hire
            </h4>
            <ul className="space-y-4" data-id="element-50">
              {[{
              name: 'Temporary Boilers',
              path: '/boiler-hire'
            }, {
              name: 'Portable Heaters',
              path: '/heater-hire'
            }, {
              name: 'Industrial Chillers',
              path: '/chiller-hire'
            }, {
              name: 'Cooling Systems',
              path: '/cooling-hire'
            }, {
              name: 'Ancillary Equipment',
              path: '/ancillaries'
            }].map(link => <li key={link.name} data-id="element-51">
                  <Link to={link.path} className="text-gray-400 hover:text-brand-amber transition-colors flex items-center group" data-id="element-52">
                    <ArrowRight className="w-4 h-4 mr-2 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-53" />
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-54">
            <h4 className="text-white font-heading font-bold text-lg mb-6" data-id="element-55">
              Company
            </h4>
            <ul className="space-y-4" data-id="element-56">
              {[{
              name: 'Our Story',
              path: '/about'
            }, {
              name: 'Sectors We Serve',
              path: '/services'
            }, {
              name: 'Contact & Depots',
              path: '/contact'
            }, {
              name: 'Privacy Policy',
              path: '#'
            }, {
              name: 'Terms of Service',
              path: '#'
            }].map(link => <li key={link.name} data-id="element-57">
                  <Link to={link.path} className="text-gray-400 hover:text-brand-amber transition-colors flex items-center group" data-id="element-58">
                    <ArrowRight className="w-4 h-4 mr-2 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-59" />
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-60">
            <h4 className="text-white font-heading font-bold text-lg mb-6" data-id="element-61">
              24/7 Support
            </h4>
            <ul className="space-y-6" data-id="element-62">
              <li className="flex items-start" data-id="element-63">
                <Phone className="w-5 h-5 text-brand-amber mr-4 mt-1 flex-shrink-0" data-id="element-64" />
                <div data-id="element-65">
                  <span className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-66">
                    Emergency Line
                  </span>
                  <a href="tel:08004647025" className="text-white font-bold text-lg hover:text-brand-amber transition-colors" data-id="element-67">
                    0800 464 7025
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-68">
                <Mail className="w-5 h-5 text-brand-amber mr-4 mt-1 flex-shrink-0" data-id="element-69" />
                <div data-id="element-70">
                  <span className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-71">
                    General Inquiries
                  </span>
                  <a href="mailto:info@rapidenergy.co.uk" className="text-gray-300 hover:text-brand-amber transition-colors" data-id="element-72">
                    info@rapidenergy.co.uk
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-73">
                <MapPin className="w-5 h-5 text-brand-amber mr-4 mt-1 flex-shrink-0" data-id="element-74" />
                <div data-id="element-75">
                  <span className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-76">
                    Coverage
                  </span>
                  <span className="text-gray-300" data-id="element-77">Nationwide UK Delivery</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-78">
          <p data-id="element-79">
            &copy; {new Date().getFullYear()} Rapid Energy. All rights reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-80">Established 2020</p>
        </div>
      </div>
    </footer>;
}